import React from 'react';
import ServiceBookingPage from '../ServiceBookingPage';

const packs = [
  {
    id: 'content_creator',
    emoji: '🥉',
    name: 'Content Creator Pack',
    description: '3 days | For solo creators & beginner coaches',
    price: 45000000,
    duration: '3 days',
    features: ['3 edited podcast episodes', '9 edited reels', 'All raw files', 'Transcriptions', 'Delivery within 5 days']
  },
  {
    id: 'brand_builder',
    emoji: '🥈',
    name: 'Brand Builder Pack',
    description: '3 days | For infopreneurs & established brands',
    price: 75000000,
    duration: '3 days',
    popular: true,
    features: ['6 edited podcast episodes', '15 edited reels', '1 streamed live + replay', 'Delivery within 7 days']
  },
  {
    id: 'launch_machine',
    emoji: '🥇',
    name: 'Launch Machine Pack',
    description: '3 days | For signature program launches',
    price: 120000000,
    duration: '3 days',
    features: ['10 edited podcast episodes', '20+ edited reels', 'Multi-platform launch live', '20 retouched photos', 'Launch trailer + VSL']
  }
];

const addons = [];

const customFields = [
  { id: 'content_niche', label: 'Your content topic / niche', type: 'text', placeholder: 'Business coaching, fitness, lifestyle...' },
  { id: 'num_people', label: 'Number of people in the studio', type: 'number', placeholder: '1' },
  { id: 'accommodation', label: 'Do you need accommodation recommendations?', type: 'select', options: [
    { value: 'yes', label: 'Yes, please send me options' },
    { value: 'no', label: 'No, I have my own accommodation' }
  ]}
];

export default function ContentRetreatBookingPage() {
  return (
    <ServiceBookingPage
      serviceType="content_retreat"
      serviceTitle="Content Retreat Bali"
      serviceSubtitle="3 days of intensive content creation"
      packs={packs}
      addons={addons}
      customFields={customFields}
      backLink="/services/content-retreat"
    />
  );
}
